export interface OptionItem {
    display: string;
    value: number;
}
